//This is for POS Print

import React from "react";
import "../stylePos.css";
import { company } from "titum-custom/details"; 
import BillHeader from "Components/Print/billHeaderPos";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";

const PrintBill = React.forwardRef((props, ref) => {
  const { submittedData,pageStatus, dividedKotData } = props;
  const { stockHistoryTemps, customer,employee,desk,room } = submittedData;

  return (

    <div className ref={ref}>

      <div className="billBody" >
        {/* <BillHeader /> */}
        <div align="center"><strong>{`KOT ${pageStatus?.recalled ? "Re-Printed" : ""} - ${submittedData.code ?? props.code}`}</strong></div>

        <div className="text-center " style={{ fontSize: 12 }}>
          <div style={{ textAlign: "center", fontSize: 12 }}>{company.address}</div>
          <div style={{ textAlign: "center", fontSize: 12 }} >TEL: {company.phone} / {company.phone2} </div>
        </div>

        <div style={{ borderTop: "1px solid #000", marginBottom: 2 }} ></div>

        <div >
          <div className="flex" style={{justifyContent:'space-between'}}>
            <strong style={{ fontSize: 11 }}> KOT: {submittedData.code}</strong> &nbsp;
            <strong style={{ fontSize: 11 }}>No: {submittedData.kotCounts}</strong>
          </div>

          <div className="flex" >
            <strong style={{ fontSize: 11 }}>{COLUMNS_NAME.EMPLOYEE}:</strong>&nbsp;
            <strong style={{ fontSize: 11, textTransform: 'capitalize' }}> {employee ? employee.fullName : submittedData?.createdBy?.username ?? "-"}</strong>
          </div>
          {desk ? 
          ( <div className="flex" >
            <strong style={{ fontSize: 11 }}>{COLUMNS_NAME.DESK}:</strong>&nbsp;
            <strong style={{ fontSize: 11 }}> {desk?.deskName}</strong>
          </div>):
          (  <div className="flex" >
            <strong style={{ fontSize: 11 }}>{COLUMNS_NAME.ROOM_NAME}:</strong>&nbsp;
            <strong style={{ fontSize: 11 }}> {room ? room.roomName : "-"}</strong>
          </div>)}
          <div className="flex" >
            <strong style={{ fontSize: 11 }}>DATE: </strong>&nbsp;
            <strong style={{ fontSize: 11 }}>{submittedData.createdAt}</strong>
          </div>
          <div className="flex" >
            <strong style={{ fontSize: 11 }}>{COLUMNS_NAME.REMARKS} : </strong>&nbsp;
            <strong style={{ fontSize: 11 }}>{submittedData.remarks}</strong>
          </div>
        </div>

        <div style={{ borderBottom: "1px solid #000", marginTop: 2 }}></div>

        <table >
          <thead>
            <tr style={{ borderBottom: "1px solid #000" }}>
              <th>#</th>
              <th  width="240px">DEC</th>
              <th align="left" >QTY</th>
              <th align="right" >Rs</th>
            </tr>
          </thead>

          <tbody>
            {props?.divideByConditionally ? 
              dividedKotData.filter(i => i.quantity > 0)
              .map((row, index) => (
                <React.Fragment key={index}>
                  <tr>
                    <td> {index + 1}.</td>
                    <td width="240px"> {row.name ? row.name : row.itemMaster ? row.itemMaster.name :  row.room.roomName } {row?.description ? `(${row?.description})` : ''}</td>
                    <td align="left">{parseFloat(row.quantity)}</td>
                    <td align="right">{parseFloat(row.retailPrice)}</td>
                  </tr>
                </React.Fragment>
              ))
            :  
            stockHistoryTemps
              .filter(i => i.quantity > 0)
              .map((row, index) => (
                <React.Fragment key={index}>
                  <tr>
                    <td> {index + 1}.</td>
                    <td width="240px"> {row.name ? row.name : row.itemMaster ? row.itemMaster.name :  row.room.roomName } {row?.description ? `(${row?.description})` : ''}</td>
                    <td align="left">{parseFloat(row.quantity)}</td>
                    <td align="right">{parseFloat(row.retailPrice)}</td>
                  </tr>
                </React.Fragment>
              ))}
          </tbody>

        </table>
        <div style={{ borderBottom: "1px solid #000" }}></div>
      </div>

    </div>
  )
});

export default PrintBill;
